import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

import { dynamicImage } from "../utils";
import { routes } from "../routers/routes";
import SignInForm from "./SignInForm";
import { Image } from "../coreComponents/Image";

const Auth = () => {
  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo" to={'/'}>
                  <Image className="img-fluid for-light" width={200} src={dynamicImage(`logo/logo-ananatra.png`)} alt="loginPage" />
                  <Image className="img-fluid for-dark" width={200} src={dynamicImage(`logo/logo-ananatra-dark.png`)} alt="loginPage" />
                </Link>
              </div>
              <div className="login-main">
                <SignInForm />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Auth;
